import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import IconText from "../../common/IconText";
import moment from "moment";
import TextWithReadMore from "../../common/TextWithReadMore";
import { generateServingsSnippet } from "../../common/util";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ImageCarousel from "../../common/component/ImageCarousel";

export default function RequestSummary(props) {
  const { request, layout } = props;

  if (layout === "dense") {
    let snippets = [];
    if (request.date) {
      snippets.push(moment(request.date).format("ddd, MMM DD, YYYY"));
    }
    if (request.servings) {
      snippets.push(generateServingsSnippet(request.servings));
    }
    if (request.budget) {
      snippets.push(`$${props.request.budget} Budget`);
    }

    return (
      <Box sx={{ display: "flex", gap: "15px" }}>
        <Box sx={{ height: "40px", width: "40px" }}>
          <ImageCarousel images={request.pics} />
        </Box>
        <Box sx={{ flexGrow: "1" }}>
          <Box>
            <Typography variant="h6" sx={{ lineHeight: "1.1" }}>
              Quote Request
            </Typography>
            <Typography variant="overline">{snippets.join(" • ")}</Typography>
          </Box>
          {request.details && request.details.length > 2 && (
            <TextWithReadMore data={request.details} limit={140} />
          )}
        </Box>
      </Box>
    );
  } else {
    return (
      <Paper elevation={0}>
        <Box>
          <Grid container>
            <Grid item sm={4} xs={5}>
              <ImageCarousel images={request.pics} />
            </Grid>
            <Grid item sm={8} xs={7}>
              <Box p={2}>
                <Box mb={1}>
                  <Typography variant="h5">{props.request.title}</Typography>
                </Box>
                <Box>
                  {props.request.date && (
                    <IconText
                      icon={EventOutlinedIcon}
                      text={`${moment(props.request.date).format("ddd, MMM DD, YYYY")} ${props.request.time ? `[${props.request.time}]` : ""} `}
                    />
                  )}
                  {props.request.servings && (
                    <IconText
                      icon={ShoppingBagOutlinedIcon}
                      text={generateServingsSnippet(props.request.servings)}
                    />
                  )}
                  {props.request.location && (
                    <IconText icon={PinDropOutlinedIcon} text={props.request.location} />
                  )}
                  {props.request.budget && (
                    <IconText
                      icon={LocalAtmOutlinedIcon}
                      text={`$${props.request.budget} Budget`}
                    />
                  )}
                </Box>
                {props.request.details && props.request.details.length > 2 && (
                  <Box pt={1}>
                    <Typography variant="overline" color="textSecondary">
                      Notes
                    </Typography>
                    <TextWithReadMore data={props.request.details} limit={140} />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    );
  }
}
